import React, { Component } from "react";

import SubSectionText from "@components/SubSectionText";
import ResearchPaper from "@components/ResearchPaper";

import report0 from "@images/Research/report0.png";
import report1 from "@images/Research/report1.png";
import report2 from "@images/Research/report2.png";
import report3 from "@images/Research/report3.png";
import report4 from "@images/Research/report4.png";
import report5 from "@images/Research/report5.png";
import report6 from "@images/Research/report6.png";
import report7 from "@images/Research/report7.png";
import report8 from "@images/Research/report8.png";
import report9 from "@images/Research/report9.png";
import report10 from "@images/Research/report10.png";
import report11 from "@images/Research/report11.png";
import report12 from "@images/Research/report12.png";
import report13 from "@images/Research/report13.png";

import policy_brief0 from "@images/Research/policy_brief0.png";
import policy_brief1 from "@images/Research/policy_brief1.png";
import policy_brief2 from "@images/Research/policy_brief2.png";
import policy_brief3 from "@images/Research/policy_brief3.png";
import policy_brief4 from "@images/Research/policy_brief4.png";
import policy_brief5 from "@images/Research/policy_brief5.png";
import policy_brief6 from "@images/Research/policy_brief6.png";
import policy_brief7 from "@images/Research/policy_brief7.png";
import policy_brief8 from "@images/Research/policy_brief8.png";
import policy_brief9 from "@images/Research/policy_brief9.png";

import fact_sheet24 from "@images/Research/fact_sheet24.png";
import fact_sheet25 from "@images/Research/fact_sheet25.png";
import fact_sheet26 from "@images/Research/fact_sheet26.png";
import fact_sheet27 from "@images/Research/fact_sheet27.png";
import fact_sheet28 from "@images/Research/fact_sheet28.png";
import fact_sheet29 from "@images/Research/fact_sheet29.png";
import fact_sheet30 from "@images/Research/fact_sheet30.png";
import fact_sheet31 from "@images/Research/fact_sheet31.png";
import fact_sheet32 from "@images/Research/fact_sheet32.png";
import fact_sheet33 from "@images/Research/fact_sheet33.png";
import fact_sheet34 from "@images/Research/fact_sheet34.png";
import fact_sheet35 from "@images/Research/fact_sheet35.png";
import fact_sheet36 from "@images/Research/fact_sheet36.png";
import fact_sheet37 from "@images/Research/fact_sheet37.png";
import fact_sheet38 from "@images/Research/fact_sheet38.png";
import fact_sheet39 from "@images/Research/fact_sheet39.png";
import fact_sheet40 from "@images/Research/fact_sheet40.png";
import fact_sheet41 from "@images/Research/fact_sheet41.png";
import fact_sheet42 from "@images/Research/fact_sheet42.png";
import fact_sheet43 from "@images/Research/fact_sheet43.png";
import fact_sheet44 from "@images/Research/fact_sheet44.png";
import fact_sheet45 from "@images/Research/fact_sheet45.png";
import fact_sheet46 from "@images/Research/fact_sheet46.png";
import fact_sheet47 from "@images/Research/fact_sheet47.png";
import fact_sheet48 from "@images/Research/fact_sheet48.png";
import fact_sheet49 from "@images/Research/fact_sheet49.png";
import fact_sheet50 from "@images/Research/fact_sheet50.png";
import fact_sheet51 from "@images/Research/fact_sheet51.png";
import fact_sheet52 from "@images/Research/fact_sheet52.png";
import fact_sheet53 from "@images/Research/fact_sheet53.png";
import fact_sheet54 from "@images/Research/fact_sheet54.png";
import fact_sheet55 from "@images/Research/fact_sheet55.png";
import fact_sheet56 from "@images/Research/fact_sheet56.png";
import fact_sheet57 from "@images/Research/fact_sheet57.png";
import fact_sheet58 from "@images/Research/fact_sheet58.png";
import fact_sheet59 from "@images/Research/fact_sheet59.png";
import fact_sheet60 from "@images/Research/fact_sheet60.png";
import fact_sheet61 from "@images/Research/fact_sheet61.png";
import fact_sheet62 from "@images/Research/fact_sheet62.png";
import fact_sheet63 from "@images/Research/fact_sheet63.png";
import fact_sheet64 from "@images/Research/fact_sheet64.png";
import fact_sheet65 from "@images/Research/fact_sheet65.png";
import fact_sheet66 from "@images/Research/fact_sheet66.png";
import fact_sheet67 from "@images/Research/fact_sheet67.png";
import fact_sheet68 from "@images/Research/fact_sheet68.png";
import fact_sheet69 from "@images/Research/fact_sheet69.png";
import fact_sheet70 from "@images/Research/fact_sheet70.png";


import styles from './profileresearch.module.css';

class Research extends Component {

    render() {
        let reportsPublishByText = 'Published by the HSRC on behalf of the Department of Science, Technology and Innovation.'
        let policyBriefsPublishByText = 'Published by the HSRC.'
        let factSheetsPublishByText = 'Published by CeSTII.'

        return (
            <div className={styles.container_research}>


                <div className={styles.research_content}>
                    <SubSectionText
                        title_font="title__24px"
                        text_font="text__18px"
                        title="Insight for decision makers"
                        text="The HSRC and CeSTII study R&D in South African institutions, informing decision makers in SA and abroad. Access our latest statistical research reports, policy briefs, and fact sheets here." />
                    <div id={'reports'} >
                        <SubSectionText
                            title_font="title__24px"
                            title="Reports" />
                    </div>
                    <ResearchPaper
                        img_src={report13}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2023/24 (October 2025)"
                        text="Key findings and data tables from South Africa’s 2023/24 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/10/RD_StatisticalReport2023-24_FINAL.pdf'
                    />
                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report12}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Main Trends in South African R&D 2022/23 (September 2025)"
                        text="Analysis and commentary of the results of South Africa’s 2022/23 R&D Survey"
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/09/RD_Main-Trends_2022-23_web.pdf'
                    />
                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report11}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2022/23 (November 2024)"
                        text="Key findings and data tables from South Africa’s 2022/23 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2026/07/RD_StatisticalReport2022-23_WEB-1.pdf'
                    />
                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report10}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2021/22 (February 2024)"
                        text="Key findings and data tables from South Africa’s 2021/22 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/RD_StatisticalReport2021-22_WEB.pdf'
                    />
                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report9}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2020/21 (January 2023)"
                        text="Key findings and data tables from South Africa’s 2020/21 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2023/01/RD_StatisticalReport2020-21_WEB-FINAL.pdf'
                    />
                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report8}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Main Report 2019/20 (September 2022)"
                        text="Analysis and commentary of the results of South Africa’s 2019/20 R&D Survey"
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/08/RD_MainReport2019-20_WEB.pdf'
                    />
                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report0}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2019/20 (December 2021)"
                        text="Key findings and data tables from South Africa’s 2018/19 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/RD_StatisticalReport2019-20_-WEB.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report1}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Main Report 2018/19 (July 2021)"
                        text="Analysis and commentary on the results of South Africa’s 2018/19 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/RD_MainReport2018-19_WEB-1.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report1}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2018/19 (February 2021)"
                        text="Key findings and data tables from South Africa’s 2018/19 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/RD_StatisticalReport2018-19_WEB-1.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report2}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2017/18 (October 2019)"
                        text="Key findings and data tables from South Africa’s 2017/18 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/SA-RD-SURVEY-STATISTICAL-REPORT-201718_WEB-1.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report3}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Main Report 2017/18 (released 27 August 2020)"
                        text="Analysis and commentary on the results of South Africa’s 2017/18 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/RD-SURVEY-MAIN-REPORT-201718_WEB-1.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report4}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2016/17 (October 2018)"
                        text="Key findings and data tables from South Africa’s 2016/17 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/SA-RD-SURVEY-STATISTICAL-REPORT-201617_WEB-1.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report5}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Main Report 2016/17 (February 2019)"
                        text="Analysis and commentary on the results of South Africa’s 2016/17 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/RD-SURVEY-MAIN-REPORT-201617_WEB-1.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report6}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Main Report 2015/16 (December 2017)"
                        text="Analysis and commentary on the results of South Africa’s 2015/16 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/SA-RD-SURVEY-MAIN-ANALYSIS-REPORT-201516_WEB-1.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={report7}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D Survey Statistical Report 2015/16 (November 2017)"
                        text="Key findings and data tables from South Africa’s 2015/16 R&D Survey."
                        text_2={reportsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/SA-RD-SURVEY-STATISTICAL-REPORT-201516_WEB-1.pdf'
                    />
                    <br />

                    <text className={styles.text16px}>
                        <a href="https://hsrc.ac.za/about-cestii/measuring-rd-activity-in-south-africa/">
                            <text className={styles.text18pxOrange}>Access the full report series (2001-2024) here</text>
                        </a>
                        <text>&nbsp;</text>
                    </text>


                    <div style={{ margin: "5%" }} />

                    <div id={'policybriefs'}>
                        <SubSectionText
                            title_font="title__24px"
                            title="Policy Briefs" style={{ marginBottom: 15 }}
                        />
                    </div>

                    <ResearchPaper
                        img_src={policy_brief9}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Promoting a science, technology and innovation policy for inclusive development in South Africa"
                        text="South Africa is at the cutting edge of innovation policy in proposing to develop a coherent, comprehensive cross-government national strategy for innovation for inclusive development (IID)."
                        text_2="By G. Kruss, I. Petersen, J. Rust, A. Tele (March 2017)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/03_HSRC-POLICY-BRIEF-SciTech-Innovation.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={policy_brief6}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Adoption and diffusion of advanced ICTs in South Africa's agricultural sector: Policy issues and implications"
                        text="South African agriculture is starting to adopt and use sophisticated information and communication technologies with positive innovation outcomes."
                        text_2="By Y. Buchana, M. M. Sithole, P. Majokweni (April 2022)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/05/Adoption-and-diffusion-of-advanced-ICTs.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={policy_brief7}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Policy levers to boost innovation and productivity in South African manufacturing firms"
                        text="The expansion of existing innovation incentives is urgently needed to help reverse the decline in South Africa’s manufacturing sector"
                        text_2="By A. Kahn (March 2022)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/05/Policy-levers-to-boost-innovation.pdf'
                    />
                    <div className={styles.divider} />


                    <ResearchPaper
                        img_src={policy_brief8}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="From crisis to survival: How informal enterprises harness the power of innovation"
                        text="Understanding how successful informal enterprises evolve into sustainable, profitable businesses can inform effective policy and support a flourishing informal business sector."
                        text_2="By N. Mustapha, I. Petersen, G. Kruss, N Van Rheede (March 2022)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/05/Crisis-to-survival.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={policy_brief0}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="R&D the biggest business casualty of Covid-19?"
                        text="Reduced spending on R&D has negatively impacted economic growth as the economy struggles to recover from Covid-19."
                        text_2="By A. Katongo, N. Mustapha (June 2021)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/08/12075.pdf'
                    />

                    <div className={styles.divider} />
                    <ResearchPaper
                        img_src={policy_brief1}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="How well is R&D oriented to human development in South Africa?"
                        text="New STI indicators are needed to achieve inclusive and sustainable human development for South Africa."
                        text_2="By G. Kruss, MM. Sithole & Y. Buchana (February 2020)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/05/How-well-is-RD-oriented.pdf'
                    />

                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={policy_brief2}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Investment in public agricultural research in South Africa: A critical review of the evidence"
                        text="Agriculture plays a crucial role in South Africa’s economic and social development, but governments in India, China and Brazil invest more in agricultural research than South Africa does."
                        text_2="By M.M. Sithole, G. Kruss, N. Vlotman, C. Moses & N. Le Roux (March 2019)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2019/08/10787.pdf'
                    />

                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={policy_brief3}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Social sciences and humanities R&D investment in South Africa: Current priorities, future needs"
                        text="Institutional R&D planners and national policymakers must find a better balance between current priorities and future needs."
                        text_2="G. Ralphs & N. Molotja (March 2019)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/05/Social-sciences-and-humanities-RD.pdf'
                    />

                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={policy_brief4}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="The future of state-owned enterprises in South Africa: Why R&D matters"
                        text="State-owned enterprises in South Africa are crucial to industrial development. But their future depends on their ability to support the economy while remaining efficient and internationally competitive."
                        text_2="N. Mustapha, G. Kruss & G. Ralphs (March 2018)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/05/Future-of-state-owned-enterprises.pdf'
                    />

                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={policy_brief5}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Promoting a science, technology and innovation policy for inclusive development in South Africa"
                        text="South Africa is at the cutting edge of innovation policy in proposing to develop a coherent, comprehensive cross-government national strategy for innovation for inclusive development (IID)."
                        text_2="G Kruss, I Petersen, J Rust & A Teal (March 2017)"
                        text_3={policyBriefsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/03_HSRC-POLICY-BRIEF-SciTech-Innovation.pdf'
                    />

                    <br />
                    <text className={styles.text16px}>
                        <a href="https://hsrc.ac.za/about-cestii/research-outputs/">
                            <text className={styles.text18pxOrange}>Access more HSRC policy briefs here.</text>
                        </a>
                        <text>&nbsp;</text>
                    </text>


                    <div style={{ margin: "5%" }} />

                    <div id={'factsheets'}>
                        <SubSectionText
                            title_font="title__24px"
                            title="Fact Sheets"
                            style={{ marginBottom: 15 }} />
                    </div>

                    <ResearchPaper
                        img_src={fact_sheet70}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 70: Science Councils R&D 2023/24"
                        text="In 2023/24, science council R&D spending increased. This marked the highest level of science council expenditure since 2018/19 and reflected the continuation of the sector's steady recovery."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2026/05/RD2023-24_Sci-Council-Fact-Sheet.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet69}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 69: NPO R&D 2023/24"
                        text="In 2023/24, not-for-profit organisations contributed R1.159 billion to national R&D, which was the lowest level since 2018/19."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2026/05/RD2023-24_NPO-Fact-Sheet.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet68}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 68: Higher Education R&D 2023/24"
                        text="In 2023/24, national R&D expenditure rose to R28.6 billion, with the higher education sector contributing a substantial 36.4% of this total and continuing its upward trajectory with a year on year increase of R128 million."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2026/05/RD2023-24_Higher-Ed-Fact-Sheet.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet67}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 67: Government R&D 2023/24"
                        text="Government increased its spending on R&D to R2.013 billion in 2023/24, continuing a steady recovery from the low experienced in 2019/20."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2026/05/RD2023-24_Government-Fact-Sheet.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet66}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 66: Business R&D 2023/24"
                        text="Business sector spending on R&D has stabilized since the decline during the COVID-19 pandemic."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2026/05/RD2023-24_Business-Fact-Sheet.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet65}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 65: Science Councils at a glance 2022/23"
                        text="South African science councils are an essential component of the country's innovation system, each established by an act of parliament, and given a specific and unique research mandate."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/09/65.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet64}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 64: NPO's at a glance 2022/23"
                        text="Non-for-profit organizations in South Africa do research and development that is essential to meeting the demands of civil society."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/09/64.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet63}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 63: Higher Education at a glance 2022/23"
                        text="South Africa's higher education sector plays a crucial role in the country's innovation system through R&D that improves the calibre and applicability of teaching and research within academic institutions."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/09/63.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet62}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 62: Government at a glance 2022/23"
                        text="In South Africa, government is crucial to research and experimental development both as a performer and more significantly as a financer."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/09/62.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet61}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 61: Business at a glance 2022/23"
                        text="Research and experimental development in developed countries relies heavily on business to invest in R&D which increases economic growth through innovation and competitiveness in the product market."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/09/61.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet60}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 60: Green R&D and cleaner energy"
                        text="Green R&D focuses on new or significantly improved products and services resulting in reduced environmental impact and the optimisation of resources, contributing to sustainable development."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/09/60.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet59}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 59: R&D in the Mining Industry in 2021/22"
                        text="Research and experimental development (R&D) contributes to more efficient, sustainable and cost-effective ways to mine."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2025/09/59.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet58}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 58: Changing Patterns of NPO R&D 2021/22"
                        text="NPO biotechnology R&D grew substantially, reaching its highest contribution in ten years."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-58-CHANGING-PATTERN-OF-NPO-RD-202122.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet57}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 57: Science Councils R&D 2021/22"
                        text="Expenditure on R&D by science councils increased slightly in 2021/22."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-57-RD202122-SCIENCE-COUNCILS-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet56}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 56: NPO R&D 2021/22"
                        text="NPOs employed the largest percentage of female researchers compared to the government, higher education, science council and business sectors."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-56-RD202122-NPO-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet55}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 55: Higher Education R&D 2021/22"
                        text="The majority of higher education R&D spend was in the social sciences (38.9%) followed by medical and health sciences (18.2%)."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-55-RD202122-HE-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet54}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 54: Government R&D 2021/22"
                        text="National, provincial and local government departments and museums undertook government R&D in the agricultural, medical and health, and engineering sciences."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-54-RD202122-GOVERNMENT-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet53}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 53: Business R&D 2021/22"
                        text="Business expenditure on R&D increased to 35,4% of gross domestic expenditure on R&D."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-53-RD202122-BUSINESS-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet52}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 52: Unlocking Innovation: Government Funding for Innovation-Active Firms in South Africa, 2019-2021"
                        text="Many innovation-active firms relied on internal funds to finance innovation with a gap between the availability of government financial support and the application procedures to secure it."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-52-GOVERNMENT-FUNDING-FOR-INNOVATION-ACTIVE-FIRMS-IN-SA.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet51}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 51: Q&A on South African Innovation Trends 2002-2021"
                        text="The majority of South African businesses were engaged in innovation activities, but a decrease was evident over the Covid-19 pandemic."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-51-SA-INNOVATION-TRENDS-2002-2021.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet50}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 50: NPO R&D in Health 2020/21"
                        text="R&D expenditure by NPOs in the health sector continued to increase with 75.7% invested in TB, HIV/AIDS and malaria research."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-50-NPO-RD-IN-HEALTH-AT-A-GLANCE-202021.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet49}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 49: Higher Education R&D Personnel 2020/21"
                        text="Higher education personnel grew steadily from 2011/12, before decreasing by 666 heads in 2020/21."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-49-RD202021-HE-RD-PERSONNEL.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet48}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 48: Agricultural R&D 2020/21"
                        text="Expenditure on agricultural R&D decreased in 2020/21, attributed to the Covid-19 pandemic."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-48-AGRICULTURAL-RD-AT-A-GLANCE-202021.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet47}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 47: Science Councils R&D 2020/21"
                        text="Expenditure on R&D by science councils decreased in 2020/21."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-47-RD202021-SCIENCE-COUNCILS-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet46}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 46: NPO R&D 2020/21"
                        text="Foreign funders were the largest contributors to NPO R&D funding, investing 64,9%."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-46-RD202021-NPO-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet45}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 45: Higher Education R&D 2020/21"
                        text="Higher education was responsible for 41.1% of R&D spending in South Africa and employed 86,3% of South African researchers."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-45-RD202021-HE-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet44}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 44: Government R&D 2020/21"
                        text="Government expenditure on R&D increased, with agricultural sciences receiving the largest investment."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-44-RD202021-GOVERNMENT-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet43}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 43: Business R&D 2020/21"
                        text="Business expenditure on R&D fell in 2020/21."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/05/FACT-SHEET-NO-43-RD202021-BUSINESS-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet42}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 42: International Innovation Collaboration Activity by South African Businesses"
                        text="Although local R&D collaboration grew from 2016/17 to 2019/20, international collaboration dipped between 2018/19 and 2019/20."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-42-INTERNATIONAL-INNOVATION-COLLABORATION-BY-SA-BUSINESSES.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet41}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 41: R&D Spending in the Mining Sector 2018/19"
                        text="Mining contributed R1.209 billion to South African R&D, predominantly in the engineering science research field.  "
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-41-MINING-RD-SPENDING-IN-SOUTH-AFRICA-201819.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet40}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 40: Digital Technologies in South African Agribusinesses 2016-2018"
                        text="The adoption of digital technologies by agribusiness has been moderate, but some sub-sectors have benefitted from the robust uptake of digital technology."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-40-DIGITAL-TECHNOLOGIES-IN-SA-AGRIBUSINESSES2.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet39}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 39: Higher Education R&D 2019/20	"
                        text="Higher education accounts for two-thirds of all R&D personnel and was responsible for 41.4% of R&D spending in South Africa, overtaking business."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-39-RD201920-HE-AT-A-GLANCE2.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet38}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 38: NPO R&D 2019/20"
                        text="R&D expenditure by the not-for-profit sector been increasing since 2010/11 with a major focus on health R&D in communicable diseases."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-38-RD201920-NPO-SECTOR-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet37}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 37: Government R&D 2019/20"
                        text="Government expenditure on R&D decreased, with nearly half allocated to research institutes."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-37-RD201920-GOVERNMENT-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet36}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 36: Science Councils R&D 2019/20"
                        text="Expenditure on R&D increased in the science councils, focussing on national priority areas including economic development, health and education."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-36-RD201920-SCIENCE-COUNCILS-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet35}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 35: Business R&D 2019/20"
                        text="Business sector R&D supports South Africa’s economic growth, GDP and competitiveness, but is decreasing year-on-year."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-35-RD201920-BUSINESS-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />


                    <ResearchPaper
                        img_src={fact_sheet34}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 34: Manufacturing sector R&D at a glance, 2014/15 - 2018/19"
                        text="The steady decline of South Africa’s manufacturing sector over the last few years mirrors a decline in R&D."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-34-MANUFACTURING-RD-201415-201819.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet33}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 33: Agricultural R&D 2013/14 - 2017/18"
                        text="Investment in agricultural R&D can boost productivity, food security and sustainable development in developing countries like South Africa. "
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-33-AGRICULTURAL-RD-201314-201718.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet32}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 32: Green R&D 2017/18"
                        text="Green R&D that seeks to reduce environmental impacts and better manage resources is increasing in South Africa, but is it enough?"
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-32-GREEN-RD-2017183-1.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet31}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 31: Namibia South Africa Innovation Activities and Outcomes"
                        text="Investment in innovation can boost the economies of Namibia and South Africa: neighbouring states that share the challenge of decelerating economic growth."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-31-NAMIBIA-SOUTH-AFRICA-INNOVATION.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet30}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 30: Higher Education R&D 2018/19"
                        text="One-third of South Africa’s annual R&D spending is in the higher education sector. In 2017/18 this amounted to R13 billion."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-30-RD201819-HE-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet29}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 29: NPO R&D 2018/19"
                        text="Health commands the dominant share of R&D available to South Africa’s not-for-profit sector, with 75% focused on diseases like HIV/Aids, TB and Malaria."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-29-RD201819-NPO-SECTOR-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet28}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 28: Government R&D 2018/19"
                        text="Government both funds and performs R&D in South Africa, mainly through higher education institutions and science councils."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-28-RD201718-GOVERNMENT-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet27}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 27: Science Councils R&D 2018/19"
                        text="R&D expenditure for science councils declined by 13.8% in 2018/19 with the focus on national priorities including health, education and agriculture. "
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-27-RD201819-SCIENCE-COUNCILS-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet26}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 26: Business R&D 2018/19"
                        text="Business spent R1,5 billion less on R&D in 2018/19 than in 2017/18. The lion’s share of this spend was geared to solve problems at the firm level."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-26-RD201819-BUSINESS-AT-A-GLANCE.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet25}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 25: COVID:19 Impacts on South African R&D and Innovation"
                        text="R&D spend is one indicator of the resilience of a business. Despite the unprecedented challenge of COVID-19, businesses in South Africa continued to invest in R&D."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-25-COVID-19IMPACTONBUSINESS20202.pdf'
                    />
                    <div className={styles.divider} />

                    <ResearchPaper
                        img_src={fact_sheet24}
                        title_font="title__16px__bold"
                        text_font="text__16px"
                        title="Fact Sheet No. 24: Health R&D at a glance 2017/18"
                        text="Achieving better health outcomes is one of South Africa’s most pressing developmental priorities for R&D, intensified by the coronavirus pandemic."
                        text_2={factSheetsPublishByText}
                        link_url='https://hsrc.ac.za/wp-content/uploads/2024/07/FACT-SHEET-NO-24-HEALTHRD2017182.pdf'
                    />
                    <div className={styles.divider} />

                    <text className={styles.text16px}>
                        <a href="https://hsrc.ac.za/about-cestii/research-outputs/">
                            <text className={styles.text18pxOrange}>Access the full fact sheet series (2017-), visit CeSTII’s website here</text>
                        </a>
                        <text>&nbsp;</text>
                    </text>


                </div>

            </div>

        );
    }

}
export default Research;

